import React from 'react';
import {Link, Typography} from '@mui/material';
import withMainContainer from '../../components/WithMainContainer.js';
import {withTitle} from '../../title.js';
import LegalContentWrapper from './LegalContentWrapper.js';
import LegalSection from './LegalSection.js';

const PrivacyPolicy = ()=><LegalContentWrapper title="מדיניות פרטיות" lastUpdated="08.08.2025">
  <LegalSection title="1. כללי">
    <Typography>
      אנו מכבדים את פרטיותך ואת זכותך לשלוט במידע אישי.<br/>
      במדיניות זו נציג כיצד אנו אוספים, שומרים, משתמשים ומעבירים (אם בכלל) מידע הנאסף בעת השימוש באתר ובאפליקציות שלנו.<br/>
      מדיניות זו חלה על כל גולשי האתר, משתמשים בשירותים המקוונים ואפליקציות התלמידים, והיא מהווה חלק בלתי נפרד מ<Link href="/terms">תנאי השימוש</Link>.
    </Typography>
    <Typography>
      אם יש לך שאלה, בקשה או חשש בנוגע למדיניות זו או לאופן שבו אנו מטפלים במידע, ניתן לפנות אלינו בכתובת המייל <Link href="mailto:simona@simonacherry.com">simona@simonacherry.com</Link> או בעמוד <Link href="/contact">"צור קשר"</Link> באתר, ולצרף את כל הפרטים הרלוונטיים.
    </Typography>
  </LegalSection>
  <LegalSection title="2. איסוף מידע">
    <Typography>
      אינך נדרש למסור פרטים אישיים לשם גלישה חופשית בתכני האתר.
    </Typography>
    <Typography>
      מידע אישי נאסף רק במקרים הבאים:<br/>
      <ul>
        <li>פרטי קשר שנמסרו מרצונך (שם, טלפון, כתובת אימייל).</li>
        <li>קובצי Cookies לשמירת סשן התחברות (Login Session) עבור תלמידים בלבד.</li>
        <li>באפליקציות המסרים: כתובת אימייל של משתמשים שנרשמים לקבלת מסרים יומיים.</li>
        <li>כל מידע שתבחר למסור לנו ייחשב כמידע מדויק ומלא, שנמסר מרצונך החופשי.</li>
      </ul>
    </Typography>
  </LegalSection>
  <LegalSection title="3. מטרות השימוש במידע">
    <Typography>
      <ul>
        <li>מענה לפניות משתמשים ומתעניינים בשירותים.</li>
        <li>שליחת עדכונים, הצעות וניוזלטר (רק בהסכמת הנמען).</li>
        <li>ניהול חשבונות תלמידים ומתן גישה לאזור האישי.</li>
        <li>הפעלת אפליקציות המסרים, כולל מתן אפשרות לתלמידים לאסוף כתובות אימייל של לקוחותיהם ולנהל רשימות דיוור.</li>
        <li>ניתוח דפוסי שימוש לצורך שיפור האתר והשירותים.</li>
        <li>עמידה בדרישות חוק והגנה על זכויות משפטיות.</li>
      </ul>
    </Typography>
  </LegalSection>
  <LegalSection title="4. אחסון ואבטחת מידע">
    <Typography>
      המידע נשמר בבסיס נתונים (MongoDB) לשימוש פנימי בלבד.<br/>
      ננקטים אמצעי אבטחה בהתאם לדרישות חוק הגנת הפרטיות, לשמירת סודיות המידע ומניעת גישה לא מורשית. המידע יישמר כל עוד הוא דרוש לצורך מתן השירות או בהתאם לדרישות החוק.
    </Typography>
  </LegalSection>
  <LegalSection title="5. העברת מידע לצדדים שלישיים">
    <Typography>
      איננו מעבירים מידע אישי לצדדים שלישיים, למעט במקרים הבאים:<br/>
      <ul>
        <li>שימוש בשירות SendGrid לצורך שליחת הודעות דוא"ל.</li>
        <li>תלמידים המשתמשים באפליקציות המסרים יכולים לייצא רשימות מיילים לשירותי דיוור חיצוניים - פעולה זו באחריותם הבלעדית ואינה באחריותנו.</li>
      </ul>
    </Typography>
  </LegalSection>
  <LegalSection title="6. הסכמה לשימוש בעוגיות (Cookies)">
    <Typography>
      בכניסה לאתר, המשתמש מסכים לשימוש בקובצי Cookies בהתאם למדיניות זו. קובצי Cookies משמשים לצורך תפעול האתר, שיפור חוויית המשתמש, שמירת סשן התחברות לתלמידים, ובמידת הצורך - גם לצורך איסוף נתונים סטטיסטיים אנונימיים לשיפור השירות.<br/>
      המשתמש רשאי לחסום או למחוק קובצי Cookies באמצעות הגדרות הדפדפן, אך ייתכן שפעולות מסוימות באתר לא יתבצעו כראוי ללא קובצי Cookies.
    </Typography>
  </LegalSection>
  <LegalSection title="7. עיון, תיקון ומחיקת מידע">
    <Typography>
      בהתאם לחוק הגנת הפרטיות, התשמ"א-1981, כל אדם זכאי לעיין במידע שנשמר עליו, לבקש לתקנו אם הוא שגוי, או לבקש את מחיקתו.<br/>
      בקשות אלו ניתן לשלוח באמצעות המייל <Link href="mailto:simona@simonacherry.com">simona@simonacherry.com</Link> או בעמוד <Link href="/contact">"צור קשר"</Link> באתר.
    </Typography>
  </LegalSection>
  <LegalSection title="8. דיוור ישיר">
    <Typography>
      בכפוף להסכמתך המפורשת ובהתאם לחוק התקשורת (בזק ושידורים), אנו עשויים לשלוח אליך עדכונים והצעות באמצעות דוא"ל, הודעות טקסט, או אמצעים דיגיטליים אחרים.<br/>
      בכל שלב ניתן להסיר את עצמך מרשימות הדיוור באמצעות הקישור המופיע בהודעות או על-ידי פנייה ישירה אלינו.
    </Typography>
  </LegalSection>
  <LegalSection title="9. עדכון מדיניות">
    <Typography>
      מדיניות זו עשויה להתעדכן מעת לעת. תאריך העדכון האחרון מופיע בראש העמוד.<br/>
      שינויים מהותיים במדיניות יפורסמו באתר וייכנסו לתוקף עם פרסומם.
    </Typography>
  </LegalSection>
</LegalContentWrapper>;

export default withMainContainer(withTitle('מדיניות פרטיות', PrivacyPolicy));
